import {
  Facebook,
  Instagram,
  Phone,
  Mail,
  MapPin,
  Clock3,
  ArrowUpRight,
} from "lucide-react";

export default function Footer() {
  return (
    <footer
      className="
        relative
        overflow-hidden

        bg-[#0f172a]

        text-white

        font-poppins
      "
    >
      {/* ================= BACKGROUND GLOW ================= */}

      <div
        className="
          absolute
          top-[-120px]
          left-[-120px]

          w-[320px]
          h-[320px]

          bg-pink-500/10

          rounded-full

          blur-3xl
        "
      />

      <div
        className="
          absolute
          bottom-[-120px]
          right-[-120px]

          w-[320px]
          h-[320px]

          bg-blue-500/10

          rounded-full

          blur-3xl
        "
      />

      {/* ================= TOP SECTION ================= */}

      <div
        className="
          max-w-7xl
          mx-auto

          px-5
          sm:px-6

          pt-16
          pb-12

          relative
          z-10
        "
      >
        <div
          className="
            grid
            grid-cols-1
            md:grid-cols-2
            lg:grid-cols-4

            gap-12
          "
        >
          {/* ================= BRAND ================= */}

          <div className="lg:pr-6">
            {/* LOGO */}

            <a href="/" className="inline-block mb-5">
              <img
                src="/logo.png"
                alt="Confidays"
                className="h-14 object-contain"
              />
            </a>

            {/* TEXT */}

            <p
              className="
                text-[14px]
                leading-[1.9]

                text-gray-300
              "
            >
              Our mission is to empower women with comfort, confidence and
              hygiene through premium wellness products designed for modern
              lifestyles.
            </p>

            {/* SOCIALS */}

            <div className="flex items-center gap-3 mt-7">
              <SocialIcon
                href="https://www.facebook.com/Confidays/"
                icon={<Facebook size={17} />}
              />

              <SocialIcon
                href="https://instagram.com/shopconfidays/"
                icon={<Instagram size={17} />}
              />
            </div>
          </div>

          {/* ================= QUICK LINKS ================= */}

          <div>
            <h3
              className="
                text-lg
                font-semibold

                mb-6

                text-white
              "
            >
              Quick Links
            </h3>

            <ul className="space-y-4">
              <FooterLink href="/about" label="About Us" />

              <FooterLink href="/products" label="Products" />

              <FooterLink href="/blog" label="Blog" />

            

            </ul>
          </div>

          {/* ================= SUPPORT ================= */}

          <div>
            <h3
              className="
                text-lg
                font-semibold

                mb-6

                text-white
              "
            >
              Support
            </h3>

            <ul className="space-y-4">
              {/* <FooterLink href="/distributors" label="Become Distributor" /> */}

              <FooterLink href="/contact" label="Contact Us" />
              <FooterLink href="/products" label="Shop Products" />

              <FooterLink href="/contact" label="Customer Support" />

           
           
            </ul>
          </div>

          {/* ================= CONTACT ================= */}

          <div>
            <h3
              className="
                text-lg
                font-semibold

                mb-6

                text-white
              "
            >
              Contact Info
            </h3>

            <div className="space-y-5">
              {/* ADDRESS */}

              <div className="flex gap-3">
                <MapPin
                  size={18}
                  className="
                    text-pink-400
                    mt-1
                    flex-shrink-0
                  "
                />

                <p
                  className="
                    text-sm
                    leading-[1.8]

                    text-gray-300
                  "
                >
                  Pent House, Plot No. 178, KPHB, Kukatpally, Hyderabad – 500072
                </p>
              </div>

              {/* PHONE */}

              <div className="flex gap-3 items-center">
                <Phone size={17} className="text-pink-400" />

                <a
                  href="tel:+919704359405"
                  className="
                    text-sm
                    text-gray-300

                    hover:text-white
                    transition
                  "
                >
                  +91 97043 59405
                </a>
              </div>

              {/* EMAIL */}

              <div className="flex gap-3 items-center">
                <Mail size={17} className="text-pink-400" />

                <a
                  href="mailto:info@confidays.com"
                  className="
                    text-sm
                    text-gray-300

                    hover:text-white
                    transition
                  "
                >
                  info@confidays.com
                </a>
              </div>

              {/* HOURS */}

              <div className="flex gap-3 items-center">
                <Clock3 size={17} className="text-pink-400" />

                <p className="text-sm text-gray-300">Mon – Fri : 9am – 6pm</p>
              </div>
            </div>
          </div>
        </div>

        {/* ================= NEWSLETTER ================= */}

        <div
          className="
            mt-14

            rounded-[30px]

            border
            border-white/10

            bg-white/5
            backdrop-blur-xl

            p-6 md:p-8

            flex
            flex-col
            lg:flex-row

            items-center
            justify-between

            gap-6
          "
        >
          {/* LEFT */}

          <div>
            <h3
              className="
                text-2xl
                md:text-3xl

                font-bold

                mb-2
              "
            >
              Stay Connected
            </h3>

            <p
              className="
                text-gray-300

                text-sm
                md:text-[15px]
              "
            >
              Get wellness updates, new launches and exclusive offers from
              Confidays.
            </p>
          </div>

          {/* INPUT */}

          <div
            className="
              w-full
              lg:w-auto

              flex
              flex-col
              sm:flex-row

              gap-3
            "
          >
            <input
              type="email"
              placeholder="Enter your email"
              className="
                min-w-[260px]

                rounded-full

                border
                border-white/10

                bg-white/10

                px-5
                py-3

                text-sm

                outline-none

                placeholder:text-gray-400

                focus:border-pink-400
              "
            />

            <button
              className="
                flex
                items-center
                justify-center
                gap-2

                rounded-full

                bg-gradient-to-r
                from-pink-500
                to-[#4F46E5]

                px-6
                py-3

                text-sm
                font-semibold

                transition-all
                duration-300

                hover:scale-[1.03]
              "
            >
              Subscribe
              <ArrowUpRight size={16} />
            </button>
          </div>
        </div>
      </div>

      {/* ================= BOTTOM BAR ================= */}

      <div
        className="
          border-t
          border-white/10

          bg-black/20
          backdrop-blur-xl
        "
      >
        <div
          className="
            max-w-7xl
            mx-auto

            px-5
            sm:px-6

            py-5

            flex
            flex-col
            md:flex-row

            items-center
            justify-between

            gap-3
          "
        >
          <p
            className="
              text-sm
              text-gray-400

              text-center
              md:text-left
            "
          >
            © 2025 <span className="text-white font-medium">Confidays</span>.
            All Rights Reserved.
          </p>

          <div
            className="
              flex
              items-center

              gap-5

              text-sm
              text-gray-400
            "
          >
            {/* <a href="/privacy" className="hover:text-white transition">
              Privacy Policy
            </a> */}

            {/* <a href="/terms" className="hover:text-white transition">
              Terms
            </a> */}
          </div>
        </div>
      </div>
    </footer>
  );
}

/* ================= REUSABLE LINK ================= */

function FooterLink({ href, label }) {
  return (
    <li>
      <a
        href={href}
        className="
          text-sm
          text-gray-300

          hover:text-pink-400

          transition-all
          duration-300
        "
      >
        {label}
      </a>
    </li>
  );
}

/* ================= SOCIAL ICON ================= */

function SocialIcon({ href, icon }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="
        w-10
        h-10

        rounded-full

        border
        border-white/10

        bg-white/5

        flex
        items-center
        justify-center

        text-gray-300

        transition-all
        duration-300

        hover:bg-pink-500
        hover:text-white
        hover:-translate-y-1
      "
    >
      {icon}
    </a>
  );
}
